import { render, staticRenderFns } from "./shiftManagementAssignment.vue?vue&type=template&id=c1d8172a&scoped=true"
import script from "./shiftManagementAssignment.vue?vue&type=script&lang=js"
export * from "./shiftManagementAssignment.vue?vue&type=script&lang=js"
import style0 from "./shiftManagementAssignment.vue?vue&type=style&index=0&id=c1d8172a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d8172a",
  null
  
)

export default component.exports